export default String.raw`
.lookbook {
    padding: 0 32px 32px 32px;

    &__item {
        &-product {
            padding: 8px;
            width: 250px;

            &.middle {
                left: -117px !important;
                right: auto !important;
            }
        }
    }
}
`